namespace GeniuzPOS.ReportMasterData {
    export interface Report_1201Form {
        ShopId: Serenity.StringEditor;
        ShopName: Serenity.StringEditor;
        PosId: Serenity.StringEditor;
        CashierId: Serenity.StringEditor;
        CashierName: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        DocTime: Serenity.TimeEditor;
        RefDocNo: Serenity.StringEditor;
        MbId: Serenity.StringEditor;
        MbNameT: Serenity.StringEditor;
        SalesmanId: Serenity.StringEditor;
        SalesmanName: Serenity.StringEditor;
        TotalItem: Serenity.DecimalEditor;
        TotalQty: Serenity.DecimalEditor;
        GrossSales: Serenity.DecimalEditor;
        AllItemDiscount: Serenity.DecimalEditor;
        AllItemCharge: Serenity.DecimalEditor;
        AdvDiscount: Serenity.DecimalEditor;
        BillDiscount: Serenity.DecimalEditor;
        NetSales: Serenity.DecimalEditor;
        BillCharge: Serenity.DecimalEditor;
        Vat: Serenity.DecimalEditor;
        DocAmt: Serenity.DecimalEditor;
        ReceiveCash: Serenity.DecimalEditor;
        ReceiveCreditCd: Serenity.DecimalEditor;
        ReceiveDebitCd: Serenity.DecimalEditor;
        ReceiveCoupon: Serenity.DecimalEditor;
        ReceiveCashCd: Serenity.DecimalEditor;
        ReceivePoint: Serenity.DecimalEditor;
        ReceiveOthers: Serenity.DecimalEditor;
        DtList: Report_1201_DtEditor;
        DiscList: Report_1201_DiscEditor;
        RecvList: Report_1201_RecvEditor;
    }

    export class Report_1201Form extends Serenity.PrefixedContext {
        static formKey = 'ReportMasterData.Report_1201';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!Report_1201Form.init)  {
                Report_1201Form.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.TimeEditor;
                var w3 = s.DecimalEditor;
                var w4 = Report_1201_DtEditor;
                var w5 = Report_1201_DiscEditor;
                var w6 = Report_1201_RecvEditor;

                Q.initFormType(Report_1201Form, [
                    'ShopId', w0,
                    'ShopName', w0,
                    'PosId', w0,
                    'CashierId', w0,
                    'CashierName', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'DocTime', w2,
                    'RefDocNo', w0,
                    'MbId', w0,
                    'MbNameT', w0,
                    'SalesmanId', w0,
                    'SalesmanName', w0,
                    'TotalItem', w3,
                    'TotalQty', w3,
                    'GrossSales', w3,
                    'AllItemDiscount', w3,
                    'AllItemCharge', w3,
                    'AdvDiscount', w3,
                    'BillDiscount', w3,
                    'NetSales', w3,
                    'BillCharge', w3,
                    'Vat', w3,
                    'DocAmt', w3,
                    'ReceiveCash', w3,
                    'ReceiveCreditCd', w3,
                    'ReceiveDebitCd', w3,
                    'ReceiveCoupon', w3,
                    'ReceiveCashCd', w3,
                    'ReceivePoint', w3,
                    'ReceiveOthers', w3,
                    'DtList', w4,
                    'DiscList', w5,
                    'RecvList', w6
                ]);
            }
        }
    }
}
